// Endereco curto do cabecalho: RUA e NUMERO, so.
//
// O endereco completo ("Parque de Exposicao Salustiano Moraes, SN, Centro,
// Santa Vitoria - MG, 38320-000") consumia a linha inteira do cartao pra
// repetir cidade, estado e CEP — que quem esta pedindo comida ja sabe. O
// destino do clique continua sendo o endereco COMPLETO no Maps, senao a
// navegacao cairia na rua errada de outra cidade.

/** "Rua X, 123" a partir dos campos separados; cai pro texto livre se preciso. */
export function enderecoCurto(companySettings) {
  const rua = String(companySettings?.logradouro || "").trim();
  const numero = String(companySettings?.numero || "").trim();
  if (rua) return numero ? `${rua}, ${numero}` : rua;

  // Loja cadastrada antes da v1.5.423 (endereco em campo unico): pega o
  // primeiro trecho, que por convencao e' "rua, numero".
  const completo = String(companySettings?.address || "").trim();
  if (!completo) return "";
  const partes = completo.split(",").map((p) => p.trim()).filter(Boolean);
  return partes.slice(0, 2).join(", ");
}

/** Endereco completo, pro link do Maps. */
export function enderecoCompleto(companySettings) {
  const c = companySettings || {};
  const montado = [
    [c.logradouro, c.numero].filter(Boolean).join(", "),
    c.bairro, c.cidade, c.uf, c.cep,
  ].filter(Boolean).join(", ");
  return montado || String(c.address || "").trim();
}
